var map = {
	"./analyst-star.svg": "./web/themes/custom/core_talents/dev/icons/analyst-star.svg",
	"./arrow-left.svg": "./web/themes/custom/core_talents/dev/icons/arrow-left.svg",
	"./arrow-right.svg": "./web/themes/custom/core_talents/dev/icons/arrow-right.svg",
	"./arrowLeft.svg": "./web/themes/custom/core_talents/dev/icons/arrowLeft.svg",
	"./arrowRight.svg": "./web/themes/custom/core_talents/dev/icons/arrowRight.svg",
	"./caret-down.svg": "./web/themes/custom/core_talents/dev/icons/caret-down.svg",
	"./circle.svg": "./web/themes/custom/core_talents/dev/icons/circle.svg",
	"./close.svg": "./web/themes/custom/core_talents/dev/icons/close.svg",
	"./facebook.svg": "./web/themes/custom/core_talents/dev/icons/facebook.svg",
	"./hat-star.svg": "./web/themes/custom/core_talents/dev/icons/hat-star.svg",
	"./hat-star2.svg": "./web/themes/custom/core_talents/dev/icons/hat-star2.svg",
	"./hat.svg": "./web/themes/custom/core_talents/dev/icons/hat.svg",
	"./kmo.svg": "./web/themes/custom/core_talents/dev/icons/kmo.svg",
	"./linkedin.svg": "./web/themes/custom/core_talents/dev/icons/linkedin.svg",
	"./lock.svg": "./web/themes/custom/core_talents/dev/icons/lock.svg",
	"./logo--white.svg": "./web/themes/custom/core_talents/dev/icons/logo--white.svg",
	"./logo-icon.svg": "./web/themes/custom/core_talents/dev/icons/logo-icon.svg",
	"./logo.svg": "./web/themes/custom/core_talents/dev/icons/logo.svg",
	"./mail.svg": "./web/themes/custom/core_talents/dev/icons/mail.svg",
	"./minsky-logo.svg": "./web/themes/custom/core_talents/dev/icons/minsky-logo.svg",
	"./navigation-background.svg": "./web/themes/custom/core_talents/dev/icons/navigation-background.svg",
	"./phone.svg": "./web/themes/custom/core_talents/dev/icons/phone.svg",
	"./play.svg": "./web/themes/custom/core_talents/dev/icons/play.svg",
	"./profile-star.svg": "./web/themes/custom/core_talents/dev/icons/profile-star.svg",
	"./search.svg": "./web/themes/custom/core_talents/dev/icons/search.svg",
	"./star--filled.svg": "./web/themes/custom/core_talents/dev/icons/star--filled.svg",
	"./star.svg": "./web/themes/custom/core_talents/dev/icons/star.svg",
	"./twitter.svg": "./web/themes/custom/core_talents/dev/icons/twitter.svg",
	"./vdab.svg": "./web/themes/custom/core_talents/dev/icons/vdab.svg"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "./web/themes/custom/core_talents/dev/icons sync recursive \\.svg$";